import {Box, Typography} from "@mui/material";
import {styled} from "@mui/material/styles";
import {useEffect} from "react";

import Loading from "../../UI/Loading/Loading";
import {useGlobalContext} from "../../../services/context.service";
import {cardAPI} from "../../../services/cardAPI.service";
import {BoxContainer} from "../../Common/SmartCardFlip";
import {fnLocalizeFilter} from "../../../services/localize.service";
import SmartCard from "../DriverCards/SmartCard/SmartCard";
import InnerContainer from "../../Common/InnerContainer";

export default function MyCard() {
    /* Получаем языковую локаль */
    const {locale} = useGlobalContext();

    const [getCard, {data: dataCard, isLoading: isLoadingData}] = cardAPI.useLazyFetchCardDriverQuery();

    useEffect(() => {
        getCard({locale});
    }, [])

    if (isLoadingData) {
        return <BoxContainer><Loading type={"big"}/></BoxContainer>
    }

    if (!dataCard) {
        return <BoxContainer>{fnLocalizeFilter(locale, "_lang.module.cards.qr.notExistCard")}</BoxContainer>
    }


    return (<InnerContainer direction={'left'} show={true}><SmartCard/></InnerContainer>)
}
